import {DateTime} from 'luxon'
import {replace} from 'lodash'

export interface PhoneNumberInfo {
  id: number
  value: string
}

export const phoneNumberResponse = (list?: PhoneNumberInfo[]) => {
  if(!list || list.length < 1) {
    return null
  }
  return list[0].value
}

export const dateResponse = (date: string) => {
  if(!date) {
    return ''
  }
  return DateTime.fromISO(date).toMillis()
}

export const transactionDateResponse = (date: string | null) => {
  if(!date) {
    return date
  } else if(date === '99991231') {
    return 'indefinite'
  }
  return DateTime.fromSQL(date).toMillis()
}

export const payDateResponse = (date: string | null) => {
  if(!date) {
    return date
  } else if(date === '99991231') {
    return 'indefinite'
  }
  return DateTime.fromFormat(date, 'yyyyMMdd').toMillis()
}

export const dashDateResponse = (date: string | null) => {
  if(!date) {
    return date
  }
  return DateTime.fromFormat(date, 'yyyy-MM-dd').toMillis()
}

export const dateRequest = (value: number) => {
  if(!value) {
    return ''
  }
  return DateTime.fromMillis(value).toISO()
}

export const timeout = (time: number) => (new Promise((resolve) => setTimeout(resolve, time)))

export const certStatusDict = {
  0: 'pending',
  1: 'processing',
  2: 'success',
  3: 'failure',
  4: 'expired',
  null: 'failure',
  undefined: 'failure',
}

export const payResponse = (pay) => {
  if(pay === '') {
    return pay
  }
  return Number(pay)
}

export const orderRequest = (order) => {
  const dict = {
    'baseTime': '-ordering_base_time',
    'dueDate': 'due_date',
    'lowAmount': 'amount',
    'highAmount': '-amount',
    'newest': 'newest',
    'modifiedAt': '-modified_at',
  }
  return dict[order]
}

export const pageResponse = (page) => {
  const params = new URLSearchParams(page)
  return Number(params.get('page'))
}

export const offsetResponse = (page) => {
  const params = new URLSearchParams(page)
  const offset = params.get('offset')
  if(offset === null) {
    return offset
  }
  return Number(offset)
}

export const restDateResponse = (date) => {
  if(date) {
    const toDay = DateTime.local()
    const expiryDate = DateTime.fromMillis(date)
    const diff = Math.ceil(expiryDate.diff(toDay).as('days'))
    return diff || null
  }
  return null
}

export const removeDash = (string: string) => {
  return replace(string, '-', '')
}

export const propertyResponse = (data) => {
  const {next, count} = data
  return {
    nextOffset: offsetResponse(next),
    count,
  }
}
